var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpinnerTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,9.941c.233-3.829,1.865-6.9,5.348-8.687a9.694,9.694,0,0,1,10.52.632A9.593,9.593,0,0,1,19.814,7.43c.107.392.489.979-.3,1.162-.633.147-.885-.185-1.076-.782a8.4,8.4,0,0,0-7.611-6.281c-4.532-.5-8.46,2.656-9.3,7.467-.7,3.993,2.348,8.4,6.441,9.322.47.106.942.206,1.42.271a.779.779,0,0,1,.734.922c-.031.658-.548.465-.921.457A10.073,10.073,0,0,1,.261,12.142,9.082,9.082,0,0,1,0,9.941Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinnerTiny);
export default __webpack_public_path__ + "static/media/icon_spinner_tiny.ffdba84e078a3d3bf2eaa6f711bdc06a.svg";
export { ForwardRef as ReactComponent };